export default __webpack_public_path__ + "static/media/laugh cute.67f5623b.gif";